module.exports = __webpack_public_path__ + "static/media/connect6Project.8dc23905.png";